// ---------------------------------------------------------

import FaqBlock from './component';

// ---------------------------------------------------------

export default FaqBlock;
